$(".optionSize").on("click", ".optionSizeSpan", function(){
  $(this).parent().find('.optionSizeSpan').removeClass('selected');
  $(this).addClass('selected');
  $(this).parent().parent().find('.buyButton span').attr("variantid", $(this).attr("variantid"));
  $(this).parent().parent().find('.buyButton span').attr("namevariant", $(this).attr("namevariant"));
  $(this).parent().parent().find('.buyButton span').attr("handle", $(this).attr("handle"));
  $(this).parent().parent().find('.buyButton span').html("ADD TO CART");
});

function addToCard(el) {
  if ($(el).attr("variantid") == undefined)
    alert("Merci de selectionner votre taille");
  else {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: $(el).attr("variantid")
      },
      dataType: 'json',           
      success: function() {
        jQuery.getJSON('/cart.js', function(cart) {
        //  var title = $(el).parent().parent().parent().find(".grid-view-item__title").html();
         // var varTitle = $(el).attr("namevariant");
       //   var url = "/products/" + $(el).attr("handle");
       //   var price = $(el).parent().parent().parent().find(".product-price__price").html();
       //   var qty = 1;
       //   var img = $(el).parent().parent().parent().find(".grid-view-item__image").attr("src");
        //  var newProductLine = '<div class="cart-item"><div class="item-image"><a href="' + url + '"><img src="' + img + '" class="item-image"></a></div><div class="item-description"><div class="smallTitle">' + title + '<br>' + varTitle + '</div><div class="smallPrice" style="text-align: left">' + price + '</div><div class="line-quantity extra-small"><span class="language language-fra">x</span><span style="margin-left: 6px">' + qty + '</span></div></div></div>';
        //  $(".items-container").append(newProductLine);
        //  $('#mini-cart-nemo').slideToggle();
            console.log(cart);
          $('#CartCount span').html(cart.item_count );
          $('#emptyCart').css("display", "none");
          $(el).html("Added !");
          $('.item_menu .number').html(parseInt($('.item_menu .number').html()) + 1);
        });
      },
      error: function() {
        alert('Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available.');
      }    
    });
  }
}

jQuery(function() {
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  });
});

$('.swatch-element').on('click', function(){
  $(this).parent().find('.swatch-element').removeClass('selected');
  $(this).addClass('selected');
});

/*
$('a').on('click', function(){
	$('body').css('opacity', '0.45');
});
*/

window.onscroll = function() {stickyHeader()};



function stickyHeader() {
  $(".header_large .site-header__logo-image img").eq(0).height(init_height);
  $(".header_large .site-header__logo-image img").eq(0).width("auto");
  if (window.pageYOffset >= stickyPos + 180) {
    $(header).addClass("first_sticky");
    $(header).addClass("sticky");
    $(".header_large .site-header__logo-image img").eq(0).attr("srcset", "https://cdn.shopify.com/s/files/1/0024/1290/4566/files/elements-01.png?17314696531725440252");
    $(".header_large .site-header__logo-image img").eq(0).attr("src", "https://cdn.shopify.com/s/files/1/0024/1290/4566/files/elements-01.png?17314696531725440252");
  }
  else if (window.pageYOffset >= stickyPos) {
    $(header).addClass("sticky");
    $(header).removeClass("first_sticky");
    $(".header_large .site-header__logo-image img").eq(0).attr("srcset", "https://cdn.shopify.com/s/files/1/0024/1290/4566/files/elements-01.png?17314696531725440252");
    $(".header_large .site-header__logo-image img").eq(0).attr("src", "https://cdn.shopify.com/s/files/1/0024/1290/4566/files/elements-01.png?17314696531725440252");
  }
  else {
    $(header).removeClass("sticky");
    $(header).removeClass("first_sticky");
    $(".header_large .site-header__logo-image img").eq(0).attr("srcset", logo);
    $(".header_large .site-header__logo-image img").eq(0).attr("src", logo);
  }
}

var screensize= $( window ).width();
console.log(screensize);
if(screensize > 768){
  console.log("er" + screensize);
  var header = $("#shopify-section-header");
  $(header).height($(header).find(".header_large").height() + 1);
  var stickyPos = $(header).height() + 1;
  header = $("#shopify-section-header .header_large");

  var logo = $(".header_large .site-header__logo-image img").eq(0).attr("srcset");
  var init_height = $(".header_large .site-header__logo-image img").eq(0).height();

}